import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import { isFunction, __DEV__, __TEST__ } from './assertions.es.js';

var callAllHandlers = function callAllHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event && event.defaultPrevented;
    });
  };
};

var runIfFn = function runIfFn(value) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return isFunction(value) ? value.apply(void 0, args) : value;
};

var warnings =
/* @__PURE__ */
new Set();

var warn = function warn(options) {
  var condition = options.condition,
      message = options.message;

  if (!condition || !__DEV__ || __TEST__) {
    return;
  }

  var key = message.toLowerCase().replace(/([^A-Za-z0-9[\]{}_:-])\s?/g, "");

  if (warnings.has(key)) {
    return;
  }

  warnings.add(key);
  console.warn("%c Maestro", "font-weight: bold; font-size: 1.05em;", "\n", message);
};

var error = function error(options) {
  var condition = options.condition,
      message = options.message;

  if (!condition || !__DEV__) {
    return;
  }

  var key = message.toLowerCase().replace(/([^A-Za-z0-9[\]{}_:-])\s?/g, "");

  if (warnings.has(key)) {
    return;
  }

  warnings.add(key);
  console.error("%c Maestro", "font-weight: bold; font-size: 1.05em;", "\n", message);
};

var noop = function noop() {
  return;
};

export { callAllHandlers, error, noop, runIfFn, warn };